<div class="reference-form" [formGroup]="formGroupContainer">
  <mat-form-field>
    <mat-label>Platform:</mat-label>
    <mat-select formControlName="platform" placeholder="Source platform">
      <mat-option *ngFor="let platform of possible_platforms" [value]="platform.code">{{ platform.title }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Identifier:</mat-label>
    <input matInput formControlName="identifier" placeholder="Source identifier" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Label:</mat-label>
    <input matInput formControlName="label" placeholder="Label" />
  </mat-form-field>

  <div class="remove-button-wrapper">
    <button mat-raised-button type="button" color="warn" (click)="removeReferenceEntry()">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Remove</span>
    </button>
  </div>
</div>
